import { h, Component } from 'preact';
import { Router, route } from 'preact-router';
import { Provider, connect } from 'preact-redux';
import { Auth } from 'aws-amplify';

import { createAppStore } from '../state/stores/AppStore';

import Home from '../routes/home';
import Details from '../routes/details';
import Story from '../routes/story';
import Gifts from '../routes/gifts';
import Rsvp from '../routes/rsvp';
import Travel from '../routes/travel';
import WeddingParty from '../routes/wedding-party';
import Login from '../routes/login';
import NotFound from '../routes/404';


export default class App extends Component {
  constructor(props) {
    super(props);

    this.store = createAppStore();
		//this.store.subscribe(this.handleState);
		//this.handleState = this.handleState.bind(this);

		Auth.currentAuthenticatedUser()
		.catch((err) => {
      route('/login', true);
		});
  }

  handleRoute(props) {
		if (!this.store.getState().authentication.authenticated) {
      route('/login', true);
    };
  }

	render() {
		return (
      <Provider store={this.store}>
			  <div id="app">
				  <Router onChange={this.handleRoute.bind(this)}>
					  <Home path="/" />
					  <Login path="/login" />
					  <Details path="/details" />
					  <Gifts path="/gifts" />
					  <WeddingParty path="/wedding-party" />
					  <Rsvp path="/rsvp" />
					  <Travel path="/travel" />
					  <Story path="/story" />
					  <NotFound default />
				  </Router>
			  </div>
      </Provider>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js